import React, { useState } from 'react';
import ReactSVG from 'react-svg';
import Truncate from 'react-truncate';
import chevron from 'chevron-small.svg';

export default function DescriptionTruncate({ description }) {
  const [truncated, setTruncated] = useState(true);

  return (
    <section className="mls-description-container">
      <p>
        {truncated ? <Truncate lines={7}>{description}</Truncate> : description}
      </p>

      <button
        className={`read-more-container ${truncated ? 'truncated' : 'full'}`}
        type="button"
        aria-label="Read More"
        title="Read More"
        onClick={() => setTruncated(!truncated)}
      >
        <span>Read More</span>
        <ReactSVG src={chevron} />
      </button>
    </section>
  );
}
